// Time page export (QA batch 15, TIME-029): every entry matching the filters
// (not just the page on screen), with Type, Status and Total like the list.
import moment from "moment";

import { timeFormatter } from "../../constants/constants";
import { ITime } from "../../types/types";

/** filter-time sorts and pages in memory on the server; one call of this size. */
export const TIME_EXPORT_MAX_ROWS = 5000;

export const timeStatusLabel = (time: Pick<ITime, "isBilled" | "isBillable">) =>
  time.isBilled
    ? "Billed"
    : time.isBillable === false
    ? "Non-billable"
    : "Unbilled";

/** Same amount as the list's Total column: hourly rate x hours; 0 when non-billable. */
export const timeTotalAmount = (time: ITime): number => {
  if (time.isBillable === false) return 0;
  const seconds = time.duration || 0;
  const hours =
    Math.floor(seconds / 3600) + Math.floor((seconds % 3600) / 60) / 60;
  return Math.trunc((time.assignedUser?.hourlyRate || 0) * hours);
};

export const timeExportRows = (items: ITime[]) =>
  items.map((time) => {
    const userProfile = time.assignedUser?.userProfile;
    const isSubtask = Boolean(time.jobTaskId || time.workTask);
    return {
      Date: time.date ? moment(time.date).format("YYYY-MM-DD") : "",
      Contact: time.contactId
        ? `${time.contact?.firstName || ""} ${
            time.contact?.lastName || ""
          }`.trim()
        : time.businessContact?.companyName || "",
      Work: time.work?.name || "",
      Type: isSubtask ? "Subtask" : "Work",
      Subtask: isSubtask ? time.workTask?.name || "" : "",
      "Work Type": time.work?.service?.name || "",
      "Total time": timeFormatter(time.duration || 0),
      Hours: Math.round(((time.duration || 0) / 3600) * 100) / 100,
      Total: timeTotalAmount(time),
      Status: timeStatusLabel(time),
      Assignee: userProfile
        ? `${userProfile.firstName || ""} ${userProfile.lastName || ""}`.trim()
        : "",
      Notes: time.notes || "",
    };
  });
